const euroFormatters = {
  en: Intl.NumberFormat("en-IE", {
    style: "currency",
    currency: "EUR",
  }),
  pt: Intl.NumberFormat("pt-PT", {
    style: "currency",
    currency: "EUR",
  }),
}

export function formatPrice(price, locale = "en") {
  const supportedLocale = locale === "en" ? "en" : "pt"

  return euroFormatters[supportedLocale].format(price)
}

export default {
  methods: {
    priceFormat(price) {
      const locale = this.$i18n && this.$i18n.locale === "en" ? "en" : "pt"

      return formatPrice(price, locale)
    },
  },
}
